// ABOUTME: Maps icon name strings from custom page config to @ds/coolshop icon components.
// ABOUTME: Provides a finite lookup with a default fallback icon.

import {
    AccountTreeIcon,
    BusinessCenterIcon,
    ContactsIcon,
    DescriptionIcon,
    FolderIcon,
    LanguageIcon,
    ListIcon,
    LocalOfferIcon,
    SearchIcon,
    SettingsIcon,
    WorkIcon,
} from '@ds/coolshop';
import { ReactElement } from 'react';

const iconMap: Record<string, ReactElement> = {
    AccountTreeIcon: <AccountTreeIcon />,
    BusinessCenterIcon: <BusinessCenterIcon />,
    ContactsIcon: <ContactsIcon />,
    DescriptionIcon: <DescriptionIcon />,
    FolderIcon: <FolderIcon />,
    LanguageIcon: <LanguageIcon />,
    ListIcon: <ListIcon />,
    LocalOfferIcon: <LocalOfferIcon />,
    SearchIcon: <SearchIcon />,
    SettingsIcon: <SettingsIcon />,
    WorkIcon: <WorkIcon />,
};

const defaultIcon = <ListIcon />;

export function resolveIcon(iconName?: string | null): ReactElement {
    if (!iconName) return defaultIcon;
    return iconMap[iconName] ?? defaultIcon;
}
